import { PickDomain } from '../../../../shared/utilities/types/PickDomain';
import { Facet } from '../types/facet';

export function isFacetGroup({ filter }: PickDomain<Facet, 'filter'>): boolean {
    return filter.name === 'travel-type' && filter.value === 'join-a-group';
}
